import { useCallback, useState } from "react";
import { useEffectOnce } from "react-use";

import useRouter from "hooks/useRouter";

import { IUser, IVerifyEmail, socialCallback } from "request/api";
import { routerPath } from "router/routerPath";
import { Spinner } from "components/Spinner";

import { getUserCredit, saveUserCredit, UserCredit } from "utils/creditUtils";
// import useGoogleAnalytics from "hooks/useGoogleAnalytics";
import { MixpanelAnalytics } from "utils/mixpanel";
import ReactGA from "react-ga4";

const sanitizeInput = (input: string): string => {
  if (!input) return input;
  return input.replace(/[<>"']/g, "");
};

export const SocialAuthVerificationPage = () => {
  const { query, push } = useRouter();
  const [isLoading, setIsLoading] = useState(true);
  const onVerifyEmail = useCallback(() => {
    if (Object.keys(query).length > 1) {
      const sanitizedParams = {
        authuser: sanitizeInput(query.authuser),
        code: sanitizeInput(query.code),
        prompt: sanitizeInput(query.prompt),
        scope: sanitizeInput(query.scope),
      };

      socialCallback(sanitizedParams)
        .then((response) => {
          const res = response as IVerifyEmail;
          setIsLoading(false);
          if (res.data) {
            localStorage.setItem("userInfo", JSON.stringify(res.data));

            const user = res.data.user as IUser;

            if (!user) {
              throw new Error("Invalid API response");
            }

            const creditInfo = getUserCredit();

            const updatedCredit: UserCredit = {
              ...creditInfo,
              credits: user.activeSubscription.credits,
              nickname: user.name,
              token: res.data.token,
              isNeedToShowWelcomePopop: true,
              user_id: user.id,
              email: user.email,
              role: user.team.role
            };
            saveUserCredit(updatedCredit);

            const userProperties = {
              name: user.name,
              email: user.email,
              avatar: user.avatar,
              uuid: user.id,
              paying: user.activeSubscription.name !== "Free",
              plan: user.activeSubscription.name,
              // createdAt: user.created_at || new Date().toISOString(),
            };

            MixpanelAnalytics.identify(user.email, userProperties);
            ReactGA.set({ user_id: user.id, user_properties: userProperties });
            ReactGA.event({
              category:"GoogleSignIn",
              action: "signin",
              name: user.name,
              email: user.email,
            } as any);

            MixpanelAnalytics.trackEvent("signin", {
              name: user.name,
              email: user.email,
            });
          }
          push(`${routerPath.HOME}`);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [query, push]); // setUser, setUserProperties, trackEvent

  useEffectOnce(() => onVerifyEmail());

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      <div className="flex justify-between items-center mb:mb-4 border border-solid border-gray-300 px-4 py-1 md:py-4 w-full bg-[rgba(255,255,255,0.5)] sticky top-0 left-0 z-20 backdrop-blur-xl">
        <div className="flex flex-row items-end">
          <img src="/icons/canvasai-logo.svg" alt="DeftGPT" />
        </div>
        <div className="flex flex-row items-center space-x-6 md:pr-4"></div>
      </div>
      <div className="h-[calc(100vh-80px)] flex flex-row items-center justify-center">
        {isLoading && (
          <Spinner className={{ "border-[#4338CA] border-opacity-50": true }} />
        )}
      </div>
    </div>
  );
};
